var _defs, _rect, _circle, _circle2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 420,
    viewBox: "0 0 680 420",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Unified document control illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBackground",
    x1: 86,
    y1: 34,
    x2: 592,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2B67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F173C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardSurface",
    x1: 154,
    y1: 74,
    x2: 500,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F0FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "panelShadow",
    x: "-20%",
    y: "-20%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 24,
    stdDeviation: 18,
    floodColor: "#04091B",
    floodOpacity: 0.42
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 420,
    rx: 30,
    fill: "url(#heroBackground)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 566,
    cy: 88,
    r: 74,
    fill: "#29408F",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 358,
    r: 96,
    fill: "#25397D",
    opacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#panelShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 56,
    width: 268,
    height: 176,
    rx: 20,
    fill: "url(#cardSurface)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 82,
    width: 86,
    height: 18,
    rx: 9,
    fill: "#C9D8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 112,
    width: 132,
    height: 12,
    rx: 6,
    fill: "#9AB6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 136,
    width: 212,
    height: 10,
    rx: 5,
    fill: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 158,
    width: 176,
    height: 10,
    rx: 5,
    fill: "#EAF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 184,
    width: 96,
    height: 28,
    rx: 14,
    fill: "#5B8CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 198H130",
    stroke: "#F8FBFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 186L244 202L278 174",
    stroke: "#4E78F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#panelShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 78,
    width: 252,
    height: 238,
    rx: 22,
    fill: "url(#cardSurface)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 104,
    width: 112,
    height: 18,
    rx: 9,
    fill: "#C9D8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 138,
    width: 204,
    height: 72,
    rx: 18,
    fill: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 156,
    width: 54,
    height: 36,
    rx: 10,
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 156,
    width: 54,
    height: 36,
    rx: 10,
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 156,
    width: 40,
    height: 36,
    rx: 10,
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 248H572",
    stroke: "#D8E3FF",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 274H540",
    stroke: "#E9F0FF",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 340,
    r: 26,
    fill: "#0F173C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 324,
    width: 134,
    height: 32,
    rx: 16,
    fill: "#5B8CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 340H514",
    stroke: "#F8FBFF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#panelShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 268,
    width: 218,
    height: 96,
    rx: 18,
    fill: "url(#cardSurface)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 334L236 302L270 316L300 286L334 300",
    stroke: "#4E78F7",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 346H358",
    stroke: "#DCE6FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.99d0d364727a96fdd6fe2ab53a4ba310.svg";
export { ForwardRef as ReactComponent };